export const RESULT = 'RESULT'; // 꾸미기 결과 배경
export const RESULT_COVER = 'RESULT_COVER'; // 꾸미기 결과
export const IMAGE = 'IMAGE'; // 꾸미기에 사용된 이미지
export const LOGO = 'LOGO';   // 꾸미기에 사용된 로고